function logoMotionIn() {

  var tmax_optionsGlobal = {
    repeat: 0,
    repeatDelay: 0,
    yoyo: false
  };

  CSSPlugin.useSVGTransformAttr = true;

  var tl = new TimelineMax(tmax_optionsGlobal),
    path = 'svg#vivivit_logo_2 *',
    stagger_val = 0.0125,
    duration = 3;

  $.each($(path), function(i, el) {
    tl.set($(this), {
      x: '+=' + getRandom(-800, 800),
      y: '+=' + getRandom(-800, 800),
      rotation: '+=' + getRandom(-720, 720),
      scale: 0,
      opacity: 0
    });
  });

  var stagger_opts_to = {
    x: 0,
    y: 0,
    opacity: 1,
    scale: 1,
    rotation: 0,
    ease: Power4.easeInOut,
    onComplete: function(){
      $("div.loading").fadeOut(500, function(){
        $('svg#vivivit_logo_2').css('visibility', 'hidden').remove();
      });
    }
  };

  function getRandom(min, max) {
    return Math.random() * (max - min) + min;
  }

  tl.staggerTo(path, duration, stagger_opts_to, stagger_val);

  //callbackFunc();
  // NOTE: callbackでtopAnimationを呼び出すとめちゃめちゃかくかくする

}

var loadScene = require('./topAnimation.js');

$(function(){
  var ua = window.navigator.userAgent.toLowerCase();
  if (ua.indexOf('firefox') != -1) {
    $('div.loading').fadeOut(500, function(){
      $('svg#vivivit_logo_2').css('visibility', 'hidden').remove();
    });
    setTimeout(loadScene, 3000);
  } else {
    $('svg#vivivit_logo_2').css('visibility', 'visible');
    logoMotionIn();
    setTimeout(loadScene, 3000);
  }
});
